import {
    createMountsGlazingGasketConfig,
    createMountsCGFFrameVerticalConfig,
    createMountsCGFChannelHorizontalConfig,
    createMountsCGFChannelVerticalConfig,
    createMountsCGFFrameHorizontalConfig,
} from "../../base";
import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";

import { MountsService } from "@/app/services/mounts.service";

const createNoDoorsMountsCGFFrameVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameVertical(partition);

    return createMountsCGFFrameVerticalConfig().qty(0).area(length).build();
};

const createNoDoorsMountsCGFFrameHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameHorizontal(partition);

    return createMountsCGFFrameHorizontalConfig().qty(0).area(length).build();
};

const createNoDoorsMountsCGFChannelVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelVertical(partition);

    return createMountsCGFChannelVerticalConfig().qty(0).area(length).build();
};

const createNoDoorsMountsCGFChannelHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelHorizontal(partition);

    return createMountsCGFChannelHorizontalConfig().qty(0).area(length).build();
};

const createNoDoorsMountsGlazingGasketConfig = (
    partition: Partition,
): IComponentConfig => {
    const channelHorizontalLength =
        MountsService.getCGFChannelHorizontal(partition);
    const channelVerticalLength =
        MountsService.getCGFChannelVertical(partition);

    const channelLength = channelHorizontalLength + channelVerticalLength;
    const sides = 2;

    const qty = Math.round(channelLength * sides) || 0;

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

export const CGF300NoDoorsConfigs = (partition: Partition) => [
    createNoDoorsMountsCGFFrameVerticalConfig(partition),
    createNoDoorsMountsCGFFrameHorizontalConfig(partition),
    createNoDoorsMountsCGFChannelVerticalConfig(partition),
    createNoDoorsMountsCGFChannelHorizontalConfig(partition),
    createNoDoorsMountsGlazingGasketConfig(partition),
];
